import React, { Fragment } from "react";

import Button from "@ds-developer/button";
import Modal from "@ds-developer/modal";

import { InsuranceModalProps } from "./types";
import InsuranceFormFields from "./components/InsuranceFormFields";

const InsuranceModal: React.FC<InsuranceModalProps> = ({
  disabled = false,
  open = false,
  loading = false,
  title = "Insurance Modal",
  errors,
  onInsuranceStartDateChange = () => {},
  onInsuranceEndDateChange = () => {},
  onCancelClick = () => {},
  onSubmit = () => {},
  onCertificateNumberChange = () => {},
  values,
}) => {
  const formId = "insurance-form";

  const actions = (
    <Fragment>
      <Button
        onClick={onCancelClick}
        variant="outlined"
        data-test="insurance-modal-cancel-button"
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        form={formId}
        loading={loading}
        disabled={disabled || loading}
        data-test="insurance-modal-submit-button"
      >
        Save
      </Button>
    </Fragment>
  );

  return (
    <Modal actions={actions} open={open} title={title}>
      <form onSubmit={onSubmit} id={formId}>
        <InsuranceFormFields
          values={values}
          errors={errors}
          onInsuranceStartDateChange={onInsuranceStartDateChange}
          onInsuranceEndDateChange={onInsuranceEndDateChange}
          onCertificateNumberChange={onCertificateNumberChange}
        />
      </form>
    </Modal>
  );
};

export default InsuranceModal;
